export interface Answer {
  answerId: number;
  questionnaireId: number;
  questionId: number;
  answerText: string;
}

export function blankAnswer(questionId: number, questionnaireId: number): Answer {
  return {
    answerId: 0,
    answerText: '',
    questionId,
    questionnaireId,
  };
}

export function copyAnswer(answer: Answer): Answer {
  return {
    answerId: answer.answerId,
    answerText: answer.answerText,
    questionId: answer.questionId,
    questionnaireId: answer.questionnaireId,
  };
}
